/*
 * @Description:组织权限--组织用户/角色权限
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  部门: '部门',
  同步: '同步',
  人员: '人员',
  个人: '个人',
  角色: '角色',
  新建: '新建',
  系统: '系统',
  移除: '移除',
  离职: '离职',
  暂停: '暂停',
  正常: '正常',
  姓名: '姓名',
  未激活: '未激活',
  未加入: '未加入',
  主规则: '主规则',
  负责人: '负责人',
  手机号: '手机号',
  部门名称: '部门名称',
  部门主管: '部门主管',
  补充规则: '补充规则',
  角色员工: '角色员工',
  数据权限: '数据权限',
  操作权限: '操作权限',
  添加人员: '添加人员',
  新建角色: '新建角色',
  编辑角色: '编辑角色',
  选择人员: '选择人员',
  已离职用户: '已离职用户',
  仅自己数据: '仅自己数据',
  整个公司数据: '整个公司数据',
  同步数据成功: '同步数据成功',
  确认移除该员工: '确认移除该员工？',
  确认删除该角色: '确认删除该角色？',
  指定部门或人员: '指定部门或人员',
  部门名称不能为空: '部门名称不能为空',
  所在部门及以下数据: '所在部门及以下数据',
  修改前后角色名一致: '修改前后角色名一致',
  '同步数据失败，请重试': '同步数据失败，请重试',
  删除后该角色下员工将无使用权限: '删除后该角色下员工将无使用权限',
  移除后该员工将无法使用角色相应的权限: '移除后该员工将无法使用角色相应的权限',
  离职用户数据管理: '离职用户数据管理',
  停用用户数据管理: '停用用户数据管理',
  全部转移: '全部转移',
  离职前所在部门: '离职前所在部门',
  停用前所在部门: '停用前所在部门',
  停用日期: '停用日期',
  选择离职用户: '选择离职用户',
  选择停用用户: '选择停用用户',
  搜索离职人员姓名: '搜索离职人员姓名',
  搜索停用人员姓名: '搜索停用人员姓名',
  现跟进线索数: '现跟进线索数',
  现负责客户数: '现负责客户数',
  现负责商机数: '现负责商机数',
  现负责报价单数: '现负责报价单数',
  现负责销售合同数: '现负责销售合同数',
  现负责销售订单数: '现负责销售订单数',
  现负责售后服务数: '现负责售后服务数',
  变更其他负责人: '变更其他负责人',
  '请输入部门/公司名称': '请输入部门/公司名称',
  已开启坐席成员: '已开启坐席成员',
  未开启坐席成员: '未开启坐席成员',
  所属公司: '所属公司',
  坐席状态: '坐席状态',
  成员直属上级: '成员直属上级',
  性别: '性别',
  成员类型: '成员类型',
  数据来源: '数据来源',
  是否合并成员: '是否合并成员',
  最早开启坐席时间: '最早开启坐席时间',
  最近一次登录时间: '最近一次登录时间',
  未启用: '未启用',
  已启用: '已启用',
  取消合并: '取消合并',
  男: '男',
  女: '女',
  保密: '保密',
  变更部门: '变更部门',
  取消关联: '取消关联',
  新建部门: '新建部门',
  创建者: '创建者',
  自建: '自建',
  飞书: '飞书',
  失败: '失败',
  成功: '成功',
  未知: '未知',
  添加子部门: '添加子部门',
  请选择所属部门: '请选择所属部门',
  请选择负责人: '请选择负责人',
  父级部门: '父级部门',
  'tips.memberDisabledTip': '飞书同步字段，烽火内不能编辑！'
};
